export default __webpack_public_path__ + "static/media/c.fdf4ed24.wav";